import { API } from 'aws-amplify'
import { UpdateStatusByCodeFormData } from '../containers/Application/Forms/UpdateApplicationStatusByCodeForm'
import {
  Application,
  CreateApplicationData,
  CreateInstantRentApplicationData,
  PartnerLead,
  UpdateApplicationStatusParams
} from '../types/applications'
import * as zlib from 'zlib'

const makeInstaformRequest = async (
  apartmentCode: string,
  language: string,
  utfSource: string,
  formData: any,
  applicationId: string
): Promise<Application> => {
  const requestsData = {
    name: formData.firstName + ' ' + formData.lastName, // Jukka-Pekka Salonen
    email: formData.email, // molkki94@gmail.com
    phone: formData.phone, // formatPhoneNumForSmsApi(phone),
    // eslint-disable-next-line camelcase
    utf_source: utfSource || 'unknown', // oikotie
    firstName: formData.firstName,
    lastName: formData.lastName,
    apartmentCode,

    language,
    // language === 'en'
    // hasFinSSN, // TODO

    age: formData.age,
    gender: formData.gender,

    movingAbout: formData.movingAbout,

    lifeSituation: formData.lifeSituation,
    lifeSituationCustom: formData.lifeSituationCustom,
    jobSeekerNote: formData.jobSeekerNote,
    // livelihoodDescription: formData.livelihood.join(', '), // 'Työmarkkinatuen' // Підтримка ринку праці
    livelihood: formData.livelihood, // 'Työmarkkinatuen' // Підтримка ринку праці
    livelihoodCustom: formData.livelihoodCustom,

    ...(typeof formData.pets !== 'undefined' && formData.pets !== null
      ? {
        pets: formData.pets === 'none' ? 'no' : 'yes', // 'Ei'
        petType:
          formData.pets === 'none'
            ? undefined
            : formData.pets === 'myAnswer'
              ? formData.petsCustom
              : formData.pets
      }
      : {}),

    listingURL: '---', // TODO // 'https://asunnot.oikotie.fi/vuokrattavat-asunnot/eurajoki/16167279'
    readyForMoveDate: formData.readyForMoveDate, // '2021-06-01T00:00:00Z' // movingAbout === 'nextMonth'

    movingWith: formData.movingWith, // 'Yksin' // Поодинці
    // movingWith === asGroup
    movingWithAmount: formData.movingWithAmount, // movingWith === 'share' || movingWith === 'family'
    // movingWith !== 'alone'
    // movingWithDescription, // TODO
    movingWithChildrenAmount: formData.movingWithChildrenAmount,

    depositPaymentMethod: formData.depositPaymentMethod, // 'Kela:n maksusitoumus'
    // depositPaymentMethod === 'other'
    // depositPaymentDescription, // TODO
    depositPaymentMethodCustom: formData.depositPaymentMethodCustom,

    creditStatus: formData.creditStatus, // yes | no
    creditStatusNote: formData.creditStatusNote,
    // requestsData.language !== 'en' || requestsData.hasFinSSN !== 'yes'
    
    rentalDebts: formData.rentalDebts,
    // lifeSituation === 'other' || depositPaymentMethod === 'kelaObligation' || creditStatus === 'bad' || (language === 'en' && hasFinSSN === 'no')
    guarantorPossible: formData.guarantorPossible, // TODO // 'Ei' // yes | no
    // wroteNotes === 'yesy'
    notes: formData.notes,

    spouseLifeSituation: formData.spouseLifeSituation,
    spouseLifeSituationCustom: formData.spouseLifeSituationCustom,
    spouseJobSeekerNote: formData.spouseJobSeekerNote,
    spouseLivelihood: formData.spouseLivelihood,
    spouseLivelihoodCustom: formData.spouseLivelihoodCustom,
    spouseCreditStatus: formData.spouseCreditStatus,
    spouseCreditStatusNote: formData.spouseCreditStatusNote,
    spouseGuarantorPossible: formData.spouseGuarantorPossible,
    contactInformationConsent: formData.contactInformationConsent,
    marketingConsent: formData.marketingConsent,
    profilePicture: formData.profilePicture
  }
  // if (requestsData.language === 'en' && requestsData.hasFinSSN === 'yes') {
  //   requestsData.language === 'fi'
  // }
  /*
  {
    - objectId: Joi.number(),
    + listingURL: Joi.string(), 
    ? address: Joi.string(),
    + name: Joi.string().required(),
    + email: Joi.string().required(),
    + phone: Joi.string().required(),
    + language: Joi.string(),
    + lifeSituation: Joi.string(),
    + livelihoodDescription: Joi.string(),
    + movingWith: Joi.string(),
    + movingWithAmount: Joi.string(),
    -- movingWithDescription: Joi.string(),
    + pets: Joi.string(),
    + petType: Joi.string(),
    + readyForMoveDate: Joi.any(),
    + depositPaymentMethod: Joi.string(),
    + depositPaymentDescription: Joi.string(),
    + creditStatus: Joi.string(),
    - collateralDescription: Joi.string(),
    + notes: Joi.string(),
    + status: Joi.string().required()
  }    
    */
  let postUrl = '/applications/form'
  if (applicationId) {
    postUrl = `/applications/update/${applicationId}`
  }
  const application: Application = await API.post('applications', postUrl, {
    body: requestsData
  })
  return application
}

//=============================== INSTANT RENT =============================//

const startInstantRent = async (payload: CreateInstantRentApplicationData) => {
  const application: Application = await API.post(
    'applications',
    '/applications/instant-rent/start',
    {
      body: payload
    }
  )
  return application
}

const updateInstantRent = async (payload: any) => {
  const application: Application = await API.post(
    'applications',
    '/applications/instant-rent/update',
    {
      body: payload
    }
  )
  return application
}

const initiatePayment = async (payload: any) => {
  const application: Application = await API.post(
    'applications',
    '/applications/instant-rent/initiatePayment',
    {
      body: payload
    }
  )
  return application
}

const instantGeneratePDF = async (authInfo: any) => {
  const authResponse = await API.get(
    'applications',
    `/applications/${authInfo.applicationCode}?generatePdf=true`,
    {}
  )
  return authResponse
}

const getApplicationByCode = async (code: string) => {
  const application: Application = await API.get(
    'applications',
    `/applications/${code}`,
    {}
  )
  return application
}

const getApplication = async (apartmentId: string, applicationId: string) => {
  const application: Application = await API.get(
    'applications',
    `/apartments/${apartmentId}/applications/${applicationId}`,
    {}
  )
  return application
}

const getApplications = async () => {
  const response = await API.get('applications', `/applications`, {})
  const compressedData = response.body
  const binaryData = Uint8Array.from(atob(compressedData), (c) => c.charCodeAt(0))

  return new Promise<any>((resolve, reject) => {
    zlib.gunzip(binaryData, (err, decompressed) => {
      if (err) {
        reject(err)
      } else {
        const decompressedStr = new TextDecoder().decode(decompressed)
        resolve(JSON.parse(decompressedStr))
      }
    })
  })
}

const getApartmentApplications = async (apartmentId: string) => {
  const apartmentApplicationsList: Application[] = await API.get(
    'applications',
    `/apartments/${apartmentId}/applications`,
    {}
  )
  return apartmentApplicationsList
}

const updateApplicationPhoneShown = async (
  apartmentId: string,
  applicationId: string
): Promise<Application> => {
  const application: Application = await API.put(
    'applications',
    `/apartments/${apartmentId}/applications/${applicationId}/phoneShown`,
    {}
  )
  return application
}

const updateApplicationStatus = async (
  apartmentId: string,
  applicationId: string,
  status: UpdateApplicationStatusParams
) => {
  const application: Application = await API.put(
    'applications',
    `/apartments/${apartmentId}/applications/${applicationId}/status`,
    {
      body: status
    }
  )
  return application
}

const acceptApplication = async (
  apartmentId: string,
  applicationId: string,
  confirmImmediately?: boolean
) => {
  const acceptedApplication: Application = await API.put(
    'applications',
    `/apartments/${apartmentId}/applications/${applicationId}/accept`,
    { body: { confirmImmediately } }
  )
  return acceptedApplication
}

const rejectApplication = async (
  apartmentId: string,
  applicationId: string
) => {
  const rejectedApplication: Application = await API.put(
    'applications',
    `/apartments/${apartmentId}/applications/${applicationId}/reject`,
    {}
  )
  return rejectedApplication
}

const editApplication = async (
  apartmentId: string,
  applicationId: string,
  editedApplicationData: CreateApplicationData
) => {
  const updatedApplication: Application = await API.post(
    'applications',
    `/apartments/${apartmentId}/applications/${applicationId}/edit`,
    {
      body: editedApplicationData
    }
  )
  return updatedApplication
}

const removeApplicant = async (
  apartmentId: string,
  applicationId: string,
  applicantCode: string
) => {
  const application: Application = await API.del(
    'applications',
    `/apartments/${apartmentId}/applications/${applicationId}/applicants/${applicantCode}`,
    {}
  )
  return application
}

const updateApplicationAdminNotes = async (
  apartmentId: string,
  applicationId: string,
  adminNotes: any
) => {
  const application: Application = await API.post(
    'applications',
    `/apartments/${apartmentId}/applications/${applicationId}/adminNotes`,
    {
      body: adminNotes
    }
  )
  return application
}

/** only allows to update to status notInterested and noAvailableTimes */
const updateApplicationStatusByCode = async (
  code: string,
  data: UpdateStatusByCodeFormData
) => {
  const application: Application = await API.post(
    'applications',
    `/applications/${code}/status`,
    {
      body: data
    }
  )
  return application
}

const getLeadData = async (leadId: string) => {
  const partnerLead: PartnerLead = await API.get(
    'applications',
    `/applications/imported/${leadId}`,
    {}
  )
  return partnerLead
}

const getConversationData = async (applicationid: string) => {
  const conversationData: PartnerLead = await API.get(
    'applications',
    `/conversation/talk/${applicationid}`,
    {}
  )
  return conversationData
}

const initiatePaymentForPublish = async (apartmentInfo: any) => {
  const response = await API.post(
    'applications',
    '/payforpublish/initiatePayment',
    {
      body: apartmentInfo
    }
  )
  return response
}

const handlePaymentCoupon = async (couponCode: string, userId: string) => {
  const response = await API.post(
    'applications',
    '/payforpublish/handlePaymentCoupon',
    {
      body: {
        couponCode: couponCode,
        userId: userId
      }
    }
  )
  return response
}

const initiateAuthorizationForCreditScore = async (payload: any) => {
  const response = await API.post(
    'applications',
    '/payforpublish/creditScoreAuthInit',
    {
      body: payload
    }
  )
  return response
}

const generateContractPDF = async (contract: any) => {
  const response = await API.post(
    'applications',
    `/payforpublish/generateContractPDF`,
    {
      body: {
        contract: contract
      }
    }
  )
  return response
}

const sendContractForSigning = async (contract: any) => {
  const response = await API.post(
    'applications',
    `/payforpublish/sendContractForSigning`,
    {
      body: {
        contract: contract
      }
    }
  )
  return response
}

const cancelDocument = async (identifiers: any, documentId?: string) => {
  const body: any = {
    identifiers: identifiers,
    platform: 'fiksuvuokraus'
  }
  if (documentId) {
    body.documentId = documentId;
  }
  const response = await API.post(
    'applications',
    `/payforpublish/cancelDocument`,
    { body }
  )
  return response
}

const updateAfterShowingApplication = async (payload: any) => {
  const application: Application = await API.post(
    'applications',
    '/payforpublish/update',
    {
      body: payload
    }
  )
  return application
}

const listApplications = async () => {
  const applications: any = await API.get(
    'applicantWatchers',
    '/applicant_watchers/list',
    {}
  )
  return applications;
}

const getApartmentsForApplications = async (applications: any) => {
  const body = {
    applications
  }

  const apartments: any = await API.post(
    'applicantWatchers',
    '/applicant_watchers/getapartments',
    {
      body: body
    }
  )
  return apartments;
}
// const filterApplications = async (postalArea = undefined, squareMeters = undefined) => {
//   const body = {
//     squareMeters: squareMeters ? squareMeters.toString() : undefined,
//     postalArea: postalArea ? postalArea.toString() : undefined
//   }
//   const applications: any = await API.post(
//     'applicantWatchers',
//     '/applicant_watchers/filteredlist',
//     {
//       body: body
//     }
//   )
//   return applications;
// }

const orderWatcher = async (postalArea, squareMeters, email) => {
  const body = {
    querystring: {
      'pinta-ala': squareMeters,
      paikkakunta: postalArea,
      email: email,
      'watcher-type': 'rent-watcher'
    }
  }
  const applications: any = await API.post(
    'applicantWatchers',
    '/applicant_watchers',
    {
      body: body
    }
  )
  return applications;
}

const contactApplicant = async (applicationId: string, apartmentId: string, landlordUserId: string) => {
  const body = {
    applicationId,
    apartmentId,
    landlordUserId
  }
  const response = await API.post(
    'applications',
    '/contactapplicant',
    {
      body: body
    }
  )
  return response
}

// const deleteApplicationByCode = async (code: string) => {
//   const body = {
//     code
//   }
//   const response = await API.post(
//     'applications',
//     '/deletebycode',
//     {
//       body: body
//     }
//   )
//   return response
// }

const checkIfLandlordUsedChat = async (apartmentId: string, applicationId: string, apartmentUserId: string) => {
  const response = await API.get(
    'applications',
    `/apartments/${apartmentId}/applications/${applicationId}/checkIfChatUsed/${apartmentUserId}`,
    {
    }
  )
  //console.log(response)
  return response
}

const addContractInformation = async (apartmentId: string, applicationId: string, payload: any) => {
  try {
    const response = await API.post(
      'applications',
      `/apartments/${apartmentId}/applications/${applicationId}/addcontractinformation`,
      {
        body: payload
      }
    )
    console.log(response)
    return response
  } catch (error) {
    console.error('An error occurred while adding contract information', error)
    throw error
  }
}

const sendAfterShowingMail = async (email: string, code: string) => {
  try {
    const body = {
      email,
      code
    }
    const response = await API.post(
      'applications',
      '/sendaftershowingmail',
      {
        body: body
      }
    )
    console.log(response)
    return response
  } catch (error) {
    console.error('An error when sending aftershowing mail', error)
    throw error
  }
}

const deleteTalkConversation = async (conversationId: string) => {
  return API.post('applications', '/talkjs/deleteconversation', {
    body: { conversationId }
  })
}

export default {
  createApplication: makeInstaformRequest,
  acceptApplication,
  getApplication,
  getApplicationByCode,
  getApplications,
  getApartmentApplications,
  updateApplicationPhoneShown,
  updateApplicationStatus,
  rejectApplication,
  updateApplicationAdminNotes,
  removeApplicant,
  editApplication,
  updateApplicationStatusByCode,
  startInstantRent,
  initiatePayment,
  instantGeneratePDF,
  updateInstantRent,
  getLeadData,
  getConversationData,
  initiatePaymentForPublish,
  handlePaymentCoupon,
  initiateAuthorizationForCreditScore,
  generateContractPDF,
  updateAfterShowingApplication,
  sendContractForSigning,
  cancelDocument,
  listApplications,
  getApartmentsForApplications,
  orderWatcher,
  contactApplicant,
  checkIfLandlordUsedChat,
  addContractInformation,
  sendAfterShowingMail,
  deleteTalkConversation
}
